'use client'
import { Suspense } from 'react'
import AuthWrapper from './AuthWrapper'


const AuthLayout = ({ children }: Readonly<{ children: React.ReactNode }>) => {

    return (
        <>
            <Suspense>
                <AuthWrapper>
                    {children}
                </AuthWrapper>
            </Suspense>
        </>
    )
}

export default AuthLayout
